app.filter('attachmentFileName',
    function() {
        return function(file) {
            if(file.data) {
                return file.data.name;
            }
            if(file.name) {
                return file.name;
            }
            if(file.attachmentFile) {
                return file.attachmentFile.fileName;
            }
        }
    }
);